module.exports = __webpack_public_path__ + "static/media/2.ca5d2de7.jpg";